/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 *
 * @author Anton Panasenko
 * @author Misha Kokoulin
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.0
 */

export enum PhoneFormatType {
	header = 'header',
	notification = 'notification',
	msisdn = 'msisdn',
	status = 'status',
}

export const formatNumberToPhone = (number: string | number, phoneFormat?: PhoneFormatType): string => {
	if (!number) return '';
	let searchValue;
	let replaceValue;
	switch (phoneFormat) {
		case PhoneFormatType.header:
			searchValue = /(\d{3})(\d{3})(\d{4})/;
			replaceValue = '+7 ($1) $2 $3';
			break;
		case PhoneFormatType.notification:
			searchValue = /(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/;
			replaceValue = '+7 $1 $2 $3 $4';
			break;
		case PhoneFormatType.status:
			searchValue = /(\d{3})(\d{3})(\d{2})(\d{2})/;
			replaceValue = '+7 ($1) $2-$3-$4';
            break;
		case PhoneFormatType.msisdn:
			return `7${number}`;
		default:
			searchValue = /(\d{3})(\d{3})(\d{2})(\d{2})/;
			replaceValue = '+7($1)$2-$3-$4';
	}
	return number.toString().replace(searchValue, replaceValue);
};
